import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';

const Skeleton = () => {
  return <div className="bg-surface-200-bg h-[290px] skeleton rounded-500"></div>;
};

const DynamicVideoBanner = dynamic(() => import('./video-banner'), {
  ssr: false,
  loading: Skeleton
});

const VideoBanner = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicVideoBanner skeleton={skeleton} {...props} />;
};

export default VideoBanner;
